import { recommendations } from "@api/index";
import { RecommendedConditions } from "@types-runway/case";
import { mapConditionPrescriptions } from "@utils/case/conditionPrescriptions";
import { RECOMMENDATION_TIMEOUT_MS } from "@utils/constantsEnv";

const useRegionBased = () => {
  const getRegionBased = async (tripDescription: string): Promise<RecommendedConditions> => {
    try {
      const response = await recommendations.recommendationPost(
        "/region-based",
        {
          tripDescription,
        },
        { timeout: RECOMMENDATION_TIMEOUT_MS }
      );
      return {
        ...response.data,
        conditions: await mapConditionPrescriptions(response.data.conditions, 0),
      };
    } catch (error) {
      return {
        conditions: [],
        reason: "",
      };
    }
  };

  return {
    getRegionBased,
  };
};

export default useRegionBased;
